import type { TenantConfig } from '@/types/TenantConfig'

export const brooklynmuseum: TenantConfig = {
  logo: 'assets/brooklynmuseum/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#333333',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
    },
    mobileFooter: {
      textColor: '#333333',
      priceTextColor: '#333333',
    },
  },
  teaserImageSize: {
    width: 360,
    height: 360,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedContentOffset: {
        desktop: '96px',
        mobile: '78px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/brooklynmuseum/static/fonts.css',
    },
  },
}
